
















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import DynamicDivider from '@/components/DynamicDivider.vue';
import Verifier from '../scanner/Verifier.vue';
import baseAPI from '@/api/horizon-iium-luxtag/index';
import {
  ConsentPayload,
  Description,
} from '@/api/horizon-iium-luxtag/public/SubmitConsentForm';
// import parse from 'date-fns/fp/parse';

@Component({
  components: {
    DynamicDivider,
    Verifier,
  },
})
export default class CertificateInformation extends Vue {
  @Prop() public certificatePayload!: any;
  @Prop() public isCertificateView!: boolean;
  @Prop() public isRevoked!: boolean;
  @Prop() public clickedPage!: boolean;
  @Prop() public desktop!: boolean;
  @Prop() public isApproved!: boolean;
  @Prop() public merchant!: string;
  public fullName = '';
  public companyName = '';
  public phoneNo = '';
  public companyEmail = '';
  public consentProof = '';
  public reasonRequest = '';
  public submitted: boolean = false;
  public uploadId: number;
  public checked: boolean = false;

  get parsed() {
    const { exp, ...parsed } = this.certificatePayload.data;
    /* tslint:disable:no-string-literal */
    if (parsed['Day'] && parsed['Month'] && parsed['Year']) {
      parsed['Completion Date'] = this.certificatePayload.data['Day'] + ' ' + this.certificatePayload.data['Month'] + ' ' + this.certificatePayload.data['Year'];
      delete parsed['Day'];
      delete parsed['Month'];
      delete parsed['Year'];
    }
    if (parsed['Student Name']) {
      parsed['Student Name'] = this.splitString(parsed['Student Name']);
    }
    if (parsed['Classification']) {
      parsed['Classification'] = this.splitString(parsed['Classification']);
    }
    if (parsed['Others']) {
      parsed['Others'] = this.splitString(parsed['Others']);
    }
    if (parsed['Program Name']) {
      const result = parsed['Program Name'].join('\n');
      parsed['Program Name'] = this.splitString(result);
    }
    return parsed;
  }

  public splitString(str) {
    return str.replace (/(?!$|\n)([^\n]{30}(?!\n))/g, '$1\n');
  }
  get isShow() {
    return this.clickedPage;
  }
  get isDesktop() {
    return this.desktop;
  }

  public async handleUpload(file: Blob, fileList: Blob[]) {
    // @ts-ignore
    const fileExt = file.name.split('.')[1];
    if (fileExt === 'png' || fileExt === 'pdf') {
      const res = await baseAPI.upload().execute(file, this.merchant);
      this.uploadId = res.id;
    } else {
          this.$message.error('Please select png or pdf');
        }
      }

  public async submitForm() {
    const address = window.location.pathname.split('/').pop();
    const description: Description = {
      details: this.reasonRequest,
    };
    const payload: ConsentPayload = {
      full_name: this.fullName,
      company: this.companyName,
      phone_number: this.phoneNo,
      email: this.companyEmail,
      description,
      address,
      consentFormId: this.uploadId,
    };
    // if empty then not submit
    if (
      this.fullName &&
      this.companyName &&
      this.phoneNo &&
      this.companyEmail &&
      this.uploadId && this.checked
    ) {
      this.submitted = true;
      const res = await baseAPI.consent().submitForm(payload);
    } else {
      this.$message.error('Please fill in all the fields');

    }
  }
}
